import { atom } from 'infrastructure/state/jotai.wrapper'
import { atomWithRefresh } from 'jotai/utils'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { allProducts } from './masters.atoms'
import { useCallback } from 'react'
import { getVanityUrls } from './vanityUrls.utils'
import { VanityUrl, VanityUrlMap } from './vanityUrls.types'
import { useGetEditableTreeForProduct } from './tree.hooks'

export const listVanityUrlsAtom = atomWithRefresh(async () => {
  const { result, error } = await getVanityUrls()
  if (error) throw error
  return result
})

export const allVanityUrlsByProductId = atom<Promise<VanityUrlMap>>(
  async (get) => {
    const data = await get(listVanityUrlsAtom)
    if (!data) return {}

    return data.reduce<VanityUrlMap>((acc, item) => {
      return {
        ...acc,
        [item.ProductID]: {
          ...item,
        },
      }
    }, {})
  },
)

const productIdsByVanityUrl = atom(async (get) => {
  const allVanityUrls = await get(listVanityUrlsAtom)
  return allVanityUrls?.reduce<Record<string, number>>(
    (acc, { URL, ProductID }) => ({ ...acc, [URL]: ProductID }),
    {},
  )
})

export function useProductForVanityUrl() {
  const vanityUrls = useAtomValue(productIdsByVanityUrl)
  const getProduct = useGetEditableTreeForProduct()
  return useCallback(
    (vanityUrl: string) => {
      const productId = vanityUrls?.[vanityUrl]
      if (!productId) return
      return getProduct(productId)
    },
    [vanityUrls, getProduct],
  )
}

export function useProductForTreeId() {
  const products = useAtomValue(allProducts)
  return useCallback(
    (treeId?: string) => {
      if (!treeId) return
      return products.find(({ editable_tree, primary_tree_tree_id }) => {
        if (primary_tree_tree_id === treeId) return true
        return editable_tree?.tree_id === treeId
      })
    },
    [products],
  )
}

export const validateVanityUrlAtom = atom((get) => async (url: string) => {
  if (url === '') return false
  const vanityUrls = await get(listVanityUrlsAtom)
  if (!vanityUrls) return false

  const normalizedNewUrl = url.toUpperCase()
  const isUrlInUse = vanityUrls.some(
    (entry: VanityUrl) => entry.URL.toUpperCase() === normalizedNewUrl,
  )
  return !isUrlInUse
})
